import React from "react";
import { useSelector } from "react-redux";
import DataDisplay from "../../../../components/dataDisplay/dataDisplay";
import { withToggle } from "../withToggle";

const FrozenMembers = ({ qa }) => {
  const {
    totalFrozenMembersNumber,
    totalFrozenMembersNumberLink,
    totalFrozenMembersPercentChange,
    prevTotalFrozenMembersNumber,
    prevTotalFrozenMembersNumberLink,
    tooltip
  } = useSelector((state) => state.membershipUnits.membershipUnits.totalFrozen);
  const displayFrozen = useSelector((state) => state.membershipUnits.membershipUnits.displayFrozen);

  return displayFrozen ? (
    <>
      <div className="content__el">
        <DataDisplay
          label="Frozen Members"
          type="number"
          value={totalFrozenMembersNumber}
          url={totalFrozenMembersNumberLink}
          disableAnimation={qa}
          toolTipContent={tooltip}
          toolTipId="membershipUnitTotalFrozenMembers"
          changeProps={{
            changeValue: totalFrozenMembersPercentChange,
            toolTip: "Percentage change from previous month",
            showBorder: true,
            positiveColor: "#c7343e",
            negativeColor: "#21e981"
          }}
        />
      </div>
      <PreviousFrozenMembers
        title="Previous Frozen Members"
        commonProps={{
          toolTipContent: `Previous ${tooltip}`,
          toolTipId: "membershipUnitPreviousTotalFrozenMembers"
        }}
        dataPointProps={{
          type: "number",
          value: prevTotalFrozenMembersNumber,
          url: prevTotalFrozenMembersNumberLink,
          disableAnimation: qa
        }}
      />
    </>
  ) : null;
};

const PreviousFrozenMembers = withToggle(DataDisplay);

export default FrozenMembers;
